
import { popupType } from "../../types/types";
import store from "../store";

export function openPopup(type:popupType,message:string,callBack?: () => void){
    store.dispatch({
        type: "setPopupState",
        payload: {
            message,
            type,
            isOpen:true,
            callBack,
        }
    })
}
export function closePopup(){
    store.dispatch({
        type: "closePopup",
        payload:{}
    })
}